import { MessageCircle, Phone } from "lucide-react";
import { BRAND } from "@/content/site";
import { waHref } from "@/content/media";
import { useLang } from "@/lang";

export default function FloatingBar() {
  const { t, isEs } = useLang();
  return (
    <div data-testid="floating-mobile-bar" className="fixed inset-x-0 bottom-0 z-50 lg:hidden">
      <div className="mx-3 mb-[max(0.75rem,env(safe-area-inset-bottom))] grid grid-cols-2 gap-2 rounded-2xl border border-gold/25 bg-navy/95 p-2 shadow-[0_-10px_40px_rgba(0,0,0,0.45)] backdrop-blur-md">
        <a
          href={BRAND.phoneHref}
          data-testid="floating-call-btn"
          className="flex h-14 items-center justify-center gap-2 rounded-xl bg-gold text-[11px] font-bold uppercase tracking-[0.04em] text-navy transition-colors duration-300 hover:bg-gold-hover"
        >
          <Phone className="h-4 w-4 shrink-0" />
          {t.bar.call}
        </a>
        <a
          href={waHref(isEs ? "es" : "en")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-btn"
          className="flex h-14 items-center justify-center gap-2 rounded-xl bg-wa text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-300 hover:brightness-110"
        >
          <MessageCircle className="h-4 w-4 shrink-0" />
          {t.bar.wa}
        </a>
      </div>
    </div>
  );
}
